/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterInstanceFleetStateChangeReason } from './emrClusterInstanceFleetStateChangeReason';
import { EmrClusterInstanceFleetTimeline } from './emrClusterInstanceFleetTimeline';


export interface EmrClusterInstanceFleetStatus { 
    /**
     * A code representing the instance fleet status                
     */
    state?: string;
    stateChangeReason?: EmrClusterInstanceFleetStateChangeReason;
    timeline?: EmrClusterInstanceFleetTimeline;
}
